module.exports = __webpack_public_path__ + "img/service-about-2.51c8b9d2.webp";